function LobbyTeachingSlider() {
	var swiper = new Swiper(".js-lobby-teaching-slider", {
		slidesPerView: "auto",
		breakpoints: {
			// when window width is >= 992px
			992: {
				slidesPerView: 1,
				allowTouchMove: false
			}
		}
	});

	$('.js-lobby-teaching-nav').on('click', function () {
		let $this = $(this);
		let needSlide = $this.attr('data-target');
		$('.js-lobby-teaching-nav').removeClass('is-active');
		$this.addClass('is-active');
		swiper.slideTo(needSlide);
	});
}

export { LobbyTeachingSlider };